import { createSelector } from '@reduxjs/toolkit'
import { OptimizelyFeatureFlags } from 'constants/optimizely'

export const isLebtSocieteEnabled = createSelector(
  (state: App.State) => state.optimizely.optimizelyFeatureFlags,
  (optimizelyFeatureFlags): boolean => {
    return !!(optimizelyFeatureFlags[OptimizelyFeatureFlags.lebtSociete])
  },
)
